<breadcrumb [items]="breadcrumb" />
<div *ngIf="loading.main" class="text-center my-5">
    <div class="spinner-border" role="statusEncerramento"></div>
</div>
@if (!loading.main && consultation) {
<!-- <div class="card border-0 bg-body-tertiary shadow-sm mb-3">
        <div class="card-header">
            <h5 class="card-title fw-lighter mb-0">Informações do Paciente</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-6 col-md-3">
                    <label class="text-body-tertiary">Nome</label>
                    <div>{{ consultation.patient?.name }}</div>
                </div>
                <div class="col-6 col-md-3">
                    <label class="text-body-tertiary">CPF</label>
                    <div>{{ consultation.patient?.cpf }}</div>
                </div>
                <div class="col-6 col-md-3">
                    <label class="text-body-tertiary">Data de Nascimento</label>
                    <div>{{ consultation.patient?.birthDate | date:'dd/MM/yyyy' }}</div>
                </div>
                <div class="col-6 col-md-3">
                    <label class="text-body-tertiary">Telefone</label>
                    <div>{{ consultation.patient?.phone }}</div>
                </div>
            </div>
        </div>
    </div> -->

<ul class="nav nav-tabs mx-md-n4 px-md-4" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="consultation" data-bs-toggle="tab" data-bs-target="#consultation-pane"
            type="button" role="tab">Consulta</button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="transcription" data-bs-toggle="tab" data-bs-target="#transcription-pane"
            type="button" role="tab">Transcrição</button>
    </li>
</ul>
<div class="tab-content mt-4">
    <!-- CONSULTA -->
    <div class="tab-pane fade show active" id="consultation-pane" role="tabpanel" tabindex="0">
        <div class="card border-0 bg-body-tertiary shadow-sm mb-3">
            <div class="card-header">
                <h5 class="card-title fw-lighter mb-0">Informações do Médico</h5>
            </div>
            <div class="card-body">
                <div class="row justify-content-between">
                    <div class="col-6 col-md-3">
                        <label class="text-body-tertiary">Nome</label>
                        <div>{{ consultation.doctor?.name }}</div>
                    </div>
                    <div class="col-6 col-md-4">
                        <label class="text-body-tertiary">Email</label>
                        <div>{{ consultation.doctor?.email }}</div>
                    </div>
                    <div class="col-6 col-md">
                        <label class="text-body-tertiary">CRM</label>
                        <div>{{ consultation.doctor?.crm }}</div>
                    </div>
                    <div class="col-6 col-md">
                        <label class="text-body-tertiary">Telefone</label>
                        <div>{{ consultation.doctor?.phone }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border-0 bg-body-tertiary shadow-sm">
            <div class="card-header d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-3">
                    <h5 class="card-title fw-lighter mb-0">Detalhes da Consulta</h5>
                    <div class="mb-1" [innerHTML]="getScore(consultation.gravidade1a5!)"></div>
                    <small class="text-body-tertiary" *ngIf="!canEditFeedback">
                        <i class="bi bi-lock me-1"></i>Prazo de 24h para feedback encerrado
                    </small>
                </div>
                <button type="button" class="btn btn-primary" [disabled]="loading.finishButton"
                    (click)="finishConsultation()" *ngIf="consultation.statusEncerramento !== 'FINISHED'">
                    <div class="spinner-border spinner-border-sm" role="statusEncerramento"
                        *ngIf="loading.finishButton"></div>
                    <span *ngIf="!loading.finishButton">Finalizar</span>
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-6 col-md mb-3">
                        <label class="text-body-tertiary">Data</label>
                        <div>
                            {{ consultation.createdAt | date: "dd/MM/yyyy" }}
                        </div>
                    </div>
                    <div class="col-6 col-md mb-3">
                        <label class="text-body-tertiary">Início</label>
                        <div>{{ consultation.createdAt | date: "HH:mm" }}</div>
                    </div>
                    <div class="col-6 col-md mb-3">
                        <label class="text-body-tertiary">Fim</label>
                        <div>
                            {{ consultation.finishedAt | date: "HH:mm" }}
                        </div>
                    </div>
                    @if (consultation.statusEncerramento === 'FINISHED' && consultation.cidProvavel && consultation.cidProvavel !== '- - -') {
                    <div class="col-6 col-md mb-3">
                        <label class="text-body-tertiary">CID</label>
                        <div>{{ consultation.cidProvavel }}</div>
                    </div>
                    }
                    @if (consultation.statusEncerramento === 'FINISHED' && consultation.cidDescricao && consultation.cidDescricao !== '- - -') {
                    <div class="col-6 col-md mb-3">
                        <label class="text-body-tertiary">Descrição do CID</label>
                        <div>{{ consultation.cidDescricao }}</div>
                    </div>
                    }
                </div>
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">Queixa Principal</label>
                    <button *ngIf="canEditFeedback" (click)="openModal('queixaPrincipal')"
                        class="btn btn-link m-0 px-2 py-0 border-0 shadow-none" type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <div>{{ consultation.queixaPrincipal }}</div>
                    @if (consultation.avaliacoes?.["queixaPrincipal"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["queixaPrincipal"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">Exame Físico</label>
                    <button *ngIf="canEditFeedback" (click)="openModal('exameFisico')" class="btn btn-link m-0 px-2 py-0 border-0 shadow-none"
                        type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <div>{{ consultation.exameFisico }}</div>
                </div>
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">História da Doença</label>
                    <button *ngIf="canEditFeedback" (click)="openModal('historiaDaDoenca')"
                        class="btn btn-link m-0 px-2 py-0 border-0 shadow-none" type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <div>{{ consultation.historiaDaDoenca }}</div>
                    @if (consultation.avaliacoes?.["historiaDaDoenca"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["historiaDaDoenca"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">Antecedentes Pessoais/Familiares</label>
                    <button *ngIf="canEditFeedback" (click)="openModal('antecedentesPessoaisFamiliares')"
                        class="btn btn-link m-0 px-2 py-0 border-0 shadow-none" type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <div>{{ consultation.antecedentesPessoaisFamiliares }}</div>
                    @if (consultation.avaliacoes?.["antecedentesPessoaisFamiliares"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["antecedentesPessoaisFamiliares"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">Medicação de Uso Contínuo</label>
                    <button *ngIf="canEditFeedback" (click)="openModal('medicacaoUsoContinuo')"
                        class="btn btn-link m-0 px-2 py-0 border-0 shadow-none" type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <div>{{ consultation.medicacaoUsoContinuo }}</div>
                    @if (consultation.avaliacoes?.["medicacaoUsoContinuo"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["medicacaoUsoContinuo"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                @if (consultation.statusEncerramento === 'FINISHED' && consultation.cidProvavel && consultation.cidProvavel !== '- - -') {
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">CID Provável</label>
                    <div>{{ consultation.cidProvavel }}</div>
                </div>
                }
                @if (consultation.statusEncerramento === 'FINISHED' && consultation.cidDescricao && consultation.cidDescricao !== '- - -') {
                <div class="col-12 mb-4">
                    <label class="text-body-tertiary">Descrição do CID</label>
                    <div>{{ consultation.cidDescricao }}</div>
                </div>
                }
                <div class="col-12 mb-4" [class.opacity-75]="reprocessing">
                    <label class="text-body-tertiary">Hipótese Diagnóstica</label>
                    @if (reprocessing) {
                    <span class="badge text-bg-secondary ms-2">
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Reprocessando...
                    </span>
                    }
                    <button *ngIf="canEditFeedback" (click)="openModal('hipotesesDiagnostica')"
                        class="btn btn-link m-0 px-2 py-0 border-0 shadow-none" type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <ul>
                        <li *ngFor="let item of consultation.hipotesesDiagnostica">
                            {{ item }}
                        </li>
                    </ul>
                    @if (consultation.avaliacoes?.["hipotesesDiagnostica"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["hipotesesDiagnostica"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                <div class="col-12" [class.opacity-75]="reprocessing">
                    <label class="text-body-tertiary">Conduta Médica</label>
                    @if (reprocessing) {
                    <span class="badge text-bg-secondary ms-2">
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Reprocessando...
                    </span>
                    }
                    <button *ngIf="canEditFeedback" (click)="openModal('condutaMedica')" class="btn btn-link m-0 px-2 py-0 border-0 shadow-none"
                        type="button">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    @if (consultation.condutaMedica?.includes("[RESUMO_CONDUTA]") &&
                    consultation.condutaMedica?.includes("[DESCRICAO_COMPLETA_CONDUTA]")) {
                    <ul>
                        <li><strong>Resumo:</strong> {{
                            consultation.condutaMedica!.split("[RESUMO_CONDUTA]")[1].split("[/RESUMO_CONDUTA]")[0].trim()
                            }}</li>
                        <li><strong>Conduta completa:</strong> {{
                            consultation.condutaMedica!.split("[DESCRICAO_COMPLETA_CONDUTA]")[1].split("[/DESCRICAO_COMPLETA_CONDUTA]")[0].trim()
                            }}</li>
                    </ul>
                    } @else {
                    <div>{{ consultation.condutaMedica }}</div>
                    }
                    @if (reprocessing) {
                    <div class="alert alert-info py-2 px-3 mt-2 mb-0 small">
                        <i class="bi bi-info-circle me-1"></i>
                        Reprocessamento em andamento. Estamos gerando uma nova hipótese diagnóstica e conduta médica com
                        base no resultado esperado informado. Isso pode levar alguns segundos.
                    </div>
                    }
                    @if (consultation.avaliacoes?.["condutaMedica"]?.expectedValue) {
                    <div class="bg-secondary-subtle rounded px-2 pb-2 pt-1 mt-2">
                        <label class="text-body-tertiary">Resultado esperado</label>
                        <div>{{ consultation.avaliacoes?.["condutaMedica"]?.expectedValue }}</div>
                    </div>
                    }
                </div>
                @if (consultation.insightNaoFeito) {
                <div class="col-12 mt-4">
                    <label class="text-body-tertiary">Sugestão</label>
                    <div>{{ consultation.insightNaoFeito }}</div>
                </div>
                }
                @if (consultation.referenciasBibliograficas && consultation.referenciasBibliograficas.length > 0) {
                <div class="col-12 mt-4">
                    <div class="accordion" id="referenciasBibliograficasAccordion">
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#referenciasBibliograficasCollapse" aria-expanded="false">
                                    Referências bibliográficas
                                </button>
                            </h2>
                            <div id="referenciasBibliograficasCollapse" class="accordion-collapse collapse"
                                data-bs-parent="#referenciasBibliograficasAccordion">
                                <div class="accordion-body">
                                    <ul class="list-group list-group-flush">
                                        @for (referencia of consultation.referenciasBibliograficas; track $index) {
                                        <li class="list-group-item">
                                            <div class="fw-bold" role="button" data-bs-toggle="collapse"
                                                [attr.data-bs-target]="'#referenciaCollapse' + $index"
                                                aria-expanded="false">
                                                {{ referencia.formatted }}
                                            </div>
                                            <div id="referenciaCollapse{{ $index }}"
                                                class="collapse small text-body-secondary mt-2">
                                                {{ limparTrecho(referencia.content) }}
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- TRANSCRIÇÃO -->
    <div class="tab-pane fade" id="transcription-pane" role="tabpanel" tabindex="0">
        <ul class="list-group">
            <li class="list-group-item py-3" *ngFor="let transcricao of transcriptions">
                <div class="d-flex align-items-center mb-2">
                    <div class="icon-letter bg-warning-subtle text-warning-emphasis me-2"
                        *ngIf="transcricao.issuer === 'patient'">P</div>
                    <div class="icon-letter bg-primary-subtle text-primary me-2"
                        *ngIf="transcricao.issuer === 'doctor'">
                        {{ consultation.doctor?.name.charAt(0).toUpperCase() }}
                    </div>
                    <div class="fw-bold fs-7 text-dark-emphasis">
                        {{ transcricao.issuer === "patient" ? "Paciente" : consultation.doctor?.name }}
                    </div>
                </div>
                <div class="text-body-secondary fs-7">
                    {{ transcricao.transcript_text }}
                </div>
            </li>
        </ul>
    </div>
</div>
}

<ng-template #feedbackBody>
    <div class="container-fluid">
        <label class="form-label mb-2">Digite a resposta esperada:</label>

        <textarea class="form-control" rows="10" [(ngModel)]="feedback.value" [disabled]="loading.feedback"
            placeholder="Digite a resposta esperada..."></textarea>
    </div>
</ng-template>

<ng-template #feedbackFooter>
    <div class="container-fluid">
        <div class="row row-cols-4 justify-content-end">
            <button type="button" class="btn btn-light me-2" [disabled]="loading.feedback"
                (click)="closeModal()">Cancelar</button>
            <button type="button" class="btn btn-primary" [disabled]="loading.feedback" (click)="enviarFeedback()">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"
                    *ngIf="loading.feedback"></span>
                <span>{{ loading.feedback ? "" : "Enviar" }}</span>
            </button>
        </div>
    </div>
</ng-template>
